/** Join truthy class names. */
export default function cx(...parts) {
  return parts.flat().filter(Boolean).join(' ');
}
